// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textr-background {
    background-color: black;
}

.floating-text-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20vh;
    position: relative;
    z-index: 2;
    color: #fff;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    animation: floatAnimation 6s ease-in-out infinite;
    padding: 0 10px; /* Add padding for small screens */
}

.floating-text {
    background: rgba(0, 0, 0, 0.6);
    padding: 10px 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    text-shadow: 0px 4px 8px rgba(255, 255, 255, 0.6);
    animation: float 3s ease-in-out infinite;
    
}

.floating-text a {
    color: #fff;
    text-decoration: underline;
}

/* Floating animation */
@keyframes floatAnimation {
    0%, 100% {
        transform: translateY(-10px);
    }
    50% {
        transform: translateY(10px);
    }
}

/* Responsive adjustments for smaller devices */
@media (max-width: 768px) {
    .floating-text-container {
        font-size: 1.2rem; /* Slightly smaller text */
        height: auto; /* Adjust height for more flexible sizing */
        padding: 10px; /* Add padding for smaller screens */
    }
    
    .floating-text {
        padding: 8px 15px; /* Smaller padding for text */
    }
}

@media (max-width: 480px) {
    .floating-text-container {
        font-size: 1rem; /* Smaller font size for very small screens */
    }

    .floating-text {
        padding: 6px 12px; /* Further reduce padding */
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/components/TextR.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,iDAAiD;IACjD,eAAe,EAAE,kCAAkC;AACvD;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,iDAAiD;IACjD,wCAAwC;;AAE5C;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA,uBAAuB;AACvB;IACI;QACI,4BAA4B;IAChC;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,+CAA+C;AAC/C;IACI;QACI,iBAAiB,EAAE,0BAA0B;QAC7C,YAAY,EAAE,2CAA2C;QACzD,aAAa,EAAE,oCAAoC;IACvD;;IAEA;QACI,iBAAiB,EAAE,6BAA6B;IACpD;AACJ;;AAEA;IACI;QACI,eAAe,EAAE,6CAA6C;IAClE;;IAEA;QACI,iBAAiB,EAAE,2BAA2B;IAClD;AACJ","sourcesContent":[".textr-background {\r\n    background-color: black;\r\n}\r\n\r\n.floating-text-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 20vh;\r\n    position: relative;\r\n    z-index: 2;\r\n    color: #fff;\r\n    text-align: center;\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n    animation: floatAnimation 6s ease-in-out infinite;\r\n    padding: 0 10px; /* Add padding for small screens */\r\n}\r\n\r\n.floating-text {\r\n    background: rgba(0, 0, 0, 0.6);\r\n    padding: 10px 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\r\n    text-shadow: 0px 4px 8px rgba(255, 255, 255, 0.6);\r\n    animation: float 3s ease-in-out infinite;\r\n    \r\n}\r\n\r\n.floating-text a {\r\n    color: #fff;\r\n    text-decoration: underline;\r\n}\r\n\r\n/* Floating animation */\r\n@keyframes floatAnimation {\r\n    0%, 100% {\r\n        transform: translateY(-10px);\r\n    }\r\n    50% {\r\n        transform: translateY(10px);\r\n    }\r\n}\r\n\r\n/* Responsive adjustments for smaller devices */\r\n@media (max-width: 768px) {\r\n    .floating-text-container {\r\n        font-size: 1.2rem; /* Slightly smaller text */\r\n        height: auto; /* Adjust height for more flexible sizing */\r\n        padding: 10px; /* Add padding for smaller screens */\r\n    }\r\n    \r\n    .floating-text {\r\n        padding: 8px 15px; /* Smaller padding for text */\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .floating-text-container {\r\n        font-size: 1rem; /* Smaller font size for very small screens */\r\n    }\r\n\r\n    .floating-text {\r\n        padding: 6px 12px; /* Further reduce padding */\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
